'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";

/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconTelegram/index.tsx)
 */
export function IconTelegram(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M1.1 7.708c4.295-1.871 7.159-3.105 8.592-3.7C13.783 2.304 14.633 2.01 15.188 2c.121-.002.394.028.57.171a.62.62 0 0 1 .21.4c.02.114.044.375.025.58-.222 2.329-1.181 7.982-1.67 10.592-.206 1.104-.613 1.474-1.006 1.51-.856.079-1.505-.565-2.334-1.109-1.297-.85-2.03-1.379-3.288-2.208-1.455-.959-.512-1.486.317-2.347.217-.225 3.987-3.654 4.06-3.965.01-.039.018-.184-.069-.26-.086-.077-.213-.05-.305-.03-.13.03-2.201 1.399-6.214 4.108-.588.404-1.12.6-1.598.59-.526-.011-1.538-.297-2.29-.542-.923-.3-1.656-.458-1.592-.968.033-.265.398-.536 1.096-.814z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M3.375 11.135c5.369-2.339 8.949-3.88 10.74-4.626 5.114-2.127 6.177-2.497 6.87-2.509.152-.003.493.035.713.214.186.151.238.356.262.499.025.143.055.47.031.725-.277 2.912-1.476 9.979-2.086 13.24-.259 1.38-.767 1.843-1.259 1.888-1.07.099-1.881-.706-2.917-1.385-1.621-1.063-2.537-1.724-4.11-2.761-1.818-1.198-.64-1.857.396-2.933.272-.282 4.984-4.568 5.075-4.957.011-.048.022-.23-.086-.325-.108-.096-.266-.063-.381-.037-.163.037-2.752 1.748-7.768 5.134-.735.505-1.4.75-1.997.738-.658-.014-1.923-.372-2.863-.677-1.153-.375-2.07-.574-1.99-1.21.041-.332.498-.671 1.37-1.018z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTelegram is deprecated and will be archived soon. Use IconTelegram instead.
 */
export function Experimental__IconTelegram(props) {
  return /*#__PURE__*/React.createElement(IconTelegram, props);
}